<mat-card>
    <mat-card-content>
        <mat-toolbar *ngIf="!initialEmptyState" class="app-table-toolbar" animated>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                <mat-icon [svgIcon]="'v2:fi-br-search'" matIconPrefix></mat-icon>
                <input type="text"
                       matInput
                       [placeholder]="'Search....'"
                       [attr.aria-label]="'Search'"
                       [formControl]="searchControl">
            </mat-form-field>

            <flex-spacer></flex-spacer>

            <button *ngIf="!(mobileMode$ | async) && columnMap?.length > 0"
                    mat-fab extended disableRipple color="accent"
                    [extended]="!(tabletMode$ | async) && !(mobileMode$ | async)"
                    [disabled]="isLoadingInitialResults"
                    [matMenuTriggerFor]="columnsSelectorMenu">
                <mat-icon [svgIcon]="'v2:fi-br-column'"></mat-icon>
                <ng-container *ngIf="!(tabletMode$ | async) && !(mobileMode$ | async)">{{ 'Columns' }}</ng-container>
            </button>
            <mat-menu #columnsSelectorMenu="matMenu" xPosition="before" class="v2-panel" [overlapTrigger]="false">
                <ng-template [ngForOf]="availableColumns" let-column ngFor>
                    <div *ngIf="!column.hasOwnProperty('isMobile') || (column.isMobile && (mobileMode$ | async))" mat-menu-item disableRipple>
                        <mat-checkbox [checked]="selectedColumns.isSelected(column)"
                                      (change)="selectedColumns.toggle(column); storeColumns()"
                                      (click)="$event.stopPropagation()">
                            <span class="select-column-label">{{ column.title }}</span>
                        </mat-checkbox>
                    </div>
                </ng-template>

                <mat-divider></mat-divider>

                <button (click)="resetColumns()" mat-menu-item>{{ 'Reset Columns' }}</button>
            </mat-menu>

            <button-spacer *ngIf="columnMap?.length > 0 && hasFilters"></button-spacer>

            <button *ngIf="hasFilters"
                    mat-fab disableRipple color="accent"
                    [extended]="!(tabletMode$ | async) && !(mobileMode$ | async)"
                    [disabled]="isLoadingInitialResults"
                    (click)="showFilters.next(filters)">
                <mat-icon [svgIcon]="'v2:fi-br-filter'"></mat-icon>
                <ng-container *ngIf="!(tabletMode$ | async) && !(mobileMode$ | async)">{{ 'Filters' }}</ng-container>
            </button>
        </mat-toolbar>

        <section class="app-table-container" [class.initial-loading]="isLoadingInitialResults" animated>
            <mat-table [dataSource]="data"
                       [class.mobile-layout]="mobileMode$ | async"
                       appTable multiTemplateDataRows>
                <ng-content></ng-content>

                <div *matNoDataRow>
                    <ng-template #emptyState>
                        <ng-template #emptyStateContent>
                            <app-empty-state [searchTerm]="searchControl.value">
                                <span emptyStateTitle>{{ 'No results to display' }}</span>
                            </app-empty-state>
                        </ng-template>

                        <ng-container *ngIf="emptyStateRef; else emptyStateContent">
                            <ng-content select="app-empty-state"></ng-content>
                        </ng-container>
                    </ng-template>

                    <ng-container *ngIf="isLoadingResults; else emptyState">
                        <app-loading-table-state
                            [keys]="displayedColumnKeys$ | async"
                            [headerRow]="tableHeaderRef">
                        </app-loading-table-state>
                    </ng-container>
                </div>

                <ng-container matColumnDef="arrowRight">
                    <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <mat-spinner *ngIf="loadingRow$[row.id] | async" [diameter]="15" [strokeWidth]="2"></mat-spinner>
                        <mat-icon *ngIf="!(loadingRow$[row.id] | async)" class="highlight-on-hover" [svgIcon]="'v2:fi-br-next'"></mat-icon>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="workingProgressBar">
                    <mat-cell *matCellDef="let row">
                        <mat-progress-bar mode="query" color="primary" [class.active]="!isLoadingInitialResults && isLoadingResults"></mat-progress-bar>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumnKeys$ | async; sticky: true"
                                [headerRow]="true"
                                appTableRow>
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: ['workingProgressBar']; let isFirst = first"
                         [workingRow]="true"
                         [firstRow]="isFirst"
                         appTableRow>
                </mat-row>
                <mat-row *matRowDef="let row; columns: displayedColumnKeys$ | async"
                         [hasAnimation]="rowsAnimated"
                         [selectableRow]="rowSelectable"
                         (click)="selectRow(row)"
                         appTableRow
                         animated
                         fadeFrom="bottom"
                         delayed="table">
                </mat-row>
            </mat-table>
        </section>
    </mat-card-content>

    <mat-card-footer *ngIf="!initialEmptyState" animated>
        <mat-paginator [class.mobile-layout]="mobileMode$ | async"
                       [length]="resultsLength"
                       [pageSize]="pageSizeOptions[1]"
                       [pageSizeOptions]="pageSizeOptions"
                       [attr.aria-label]="'Select page of loaded results'"
                       [disabled]="isLoadingInitialResults"
                       [selectConfig]="{ panelClass: 'v2-panel' }">
        </mat-paginator>
    </mat-card-footer>
</mat-card>
